
import { motion } from 'framer-motion';

export default function DisasterPreventionSection() {
  // Immutable card data
  const infoCards = [
    { icon: 'ri-money-dollar-circle-line', label: '대상', value: '공사금액 1억~50억' },
    { icon: 'ri-calendar-check-line', label: '지도횟수', value: '1개월 2회 (공사기간/15)' },
    { icon: 'ri-file-edit-line', label: '계약시점', value: '착공 전일까지 계약체결' },
  ] as const;

  return (
    <section className="py-14 sm:py-20 bg-gradient-to-r from-[#ff6b35] to-[#ff8c5a]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          {/* Badge */}
          <div className="inline-block px-5 sm:px-6 py-1.5 sm:py-2 bg-white rounded-full text-[#1a2b4a] text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            고용노동부 지정
          </div>

          {/* Title */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-2 sm:mb-3">
            건설재해예방 전문지도기관
          </h2>
          <p className="text-sm sm:text-lg text-white/90 mb-8 sm:mb-12">
            지정번호: 제2025-050632호
          </p>

          {/* Info Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            {infoCards.map((card, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-xl"
              >
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#ff6b35]/10 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-5">
                  <i className={`${card.icon} text-[#ff6b35] text-2xl sm:text-3xl`}></i>
                </div>
                <div className="text-xs sm:text-sm text-gray-500 font-medium mb-1 sm:mb-2">
                  {card.label}
                </div>
                <div className="text-sm sm:text-lg font-bold text-[#1a2b4a]">
                  {card.value}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
